import { useParams } from 'react-router';
import { useUserDetails } from '../../helpers/UserContext';
import { useContactRoles, useStates } from '../../queries/CommonQueries';
import { useContact } from '../../queries/ContactQueries';
import AppLayout from '../../components/AppLayout';
import ShowPending from '../../components/ShowPending';
import AddUpdateContactForm from '../../components/AddUpdateContactForm';
import type { Contact } from '../../models/Contact';

export default function UpdateContact() {
  const params = useParams();
  const id = params.id ? +params.id : 0;
  const [userDetails] = useUserDetails();

  const { data: states, isPending: isStatePending } = useStates();
  const { data: contactRoles, isPending: isRolePending } = useContactRoles();
  const { data: contact, isPending } = useContact(id);

  return (
    <AppLayout>
      <main>
        <h3 className='text-center text-2xl dark:text-gray-300'>
          {id > 0 ? 'Update' : 'Add'} Contact
        </h3>
        {(id > 0 && isPending) || isRolePending || isStatePending ? (
          <ShowPending isPending={isPending} />
        ) : (
          <AddUpdateContactForm
            states={states}
            contactRoles={contactRoles}
            contact={
              contact
                ? contact
                : ({
                    contactId: 0,
                    applicationUserId: userDetails?.userId ?? '',
                    active: true,
                  } as Contact)
            }
          />
        )}
      </main>
    </AppLayout>
  );
}
